import { Autocomplete, Box, Button, FormControl, Grid, IconButton, List, ListItem, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../global/config/store.ts';
import { setSelectedClientGroup } from '../../../global/config/Reducer/clientSlice.ts';
import { ApiCheckShopperEligibility, ApiGetClientEntityByClientGroupId, ApiGetOrphanAllocations, ApiGetShopperList, ApiGetVenueList } from '../../../apiService/Core/Apicall.tsx';
import { setclientEntityIdData } from '../../../global/config/Reducer/entitySlice.ts';
import useDebounce from '../CreateAllocations/UseDebounce.tsx';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { setDate } from "../../../global/config/Reducer/dateSlice.ts"
import { toast } from 'react-toastify';

function CheckShopperEligibility() {
    const dispatch = useDispatch()
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const Clientlist = useSelector((state: RootState) => state.client.clientList)
    const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
    const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
    const [clientEntityId, setClientEntityId] = useState<any>(null)
    const debouncedClientEntityId = useDebounce(clientEntityId, 500)
    const [venueNameValue, setVenueNameValue] = useState<any>("")
    const debouncedVenue = useDebounce(venueNameValue, 700)
    const [venueName, setVenueName] = useState([])
    const [clientEntityList, setClientEntityList] = useState<any>([])
    const [searchText, setSearchText] = useState("");
    const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
    const [allocations, setAllocations] = useState<any>([])
    const [selectedAllocation, setSelecetdAllocation] = useState<number>()
    const [selectedShopper, setSelectedShopper] = useState<any>()
    const [shopperlist, setshopperlist] = useState([])
    const [searchShopper, setsearchShopper] = useState<any>([])
    const [data, setData] = useState<any>([])




    useEffect(() => {
        selectedClientName && setSelectedClient(selectedClientName)
    }, [selectedClientName])

    useEffect(() => {
        if (selectedClient?.clientGroupName) {
            handleGetClientList()
        }
    }, [selectedClient?.clientGroupName])


    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
        if (!selectedClient?.clientGroupName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            console.log(res.data)
            setClientEntityList(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }

    const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
        let data = `?offset=0&limit=500`
        if (clientEntityId) {
            data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        } else if (selectedClient?.clientGroupName) {
            data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
        }
        const res = await ApiGetVenueList(data)
        const response = res?.data.map((item: any) => ({
            label: item.venueName,
            value: item.venueId,
            state: item.state,
            entityTypeName: item.entityTypeName
        }))
        setVenueName(response)
    }

    useEffect(() => {
        if (debouncedClientEntityId || selectedClient?.clientGroupName) {
            ApiCallGetVenueList(debouncedClientEntityId)
        } else {
            setVenueName([]) // Clear venue list when business is cleared
            setVenueNameValue(null) // Also clear selected venue
        }
    }, [debouncedClientEntityId, selectedClient?.clientGroupName])



    const handlePrevMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
            dispatch(setDate(newDate))
            return newDate
        })
    }

    const handleNextMonth = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
            dispatch(setDate(newDate))
            return newDate
        })
    }


    const formatDate = (date: Date) => {
        return `${date?.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
    }


    const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newDate = new Date(event.target.value + "-01")
        dispatch(setDate(new Date(event.target.value)))
    }


    useEffect(() => {
        if (selectedDateRedux) {
            setCurrentDate(new Date(selectedDateRedux))
        }
    }, [selectedDateRedux])



    const ApiCallGetAllocations = async () => {
        if (selectedClient) {
            setAllocations([])
            let data = `?jobMonth=${currentDate.getMonth() + 1}${clientEntityId ? `&clientEntityId=${clientEntityId}` : ""}&jobYear=${currentDate?.getFullYear()}${selectedClient?.clientGroupName ? `&allocationClientGroup=${selectedClient.clientGroupName}` : ""}`

            if (venueNameValue) data += `&venueId=${venueNameValue}`

            try {
                const res: any = await ApiGetOrphanAllocations(data)
                setAllocations(res?.data || [])

            } catch (error) {
                console.error("Error during API call:", error)
                toast.error("Failed to load allocations")
            }
        }
    }


    useEffect(() => {
        if (selectedClient && currentDate) {
            const timeout = setTimeout(() => {
                ApiCallGetAllocations()
            }, 300);
            return () => clearTimeout(timeout);
        }
    }, [currentDate, selectedClient, clientEntityId, venueNameValue])


    const getShopperList = async (text: any) => {
        setshopperlist([])
        try {
            const data = `?offset=0&limit=1000&status=active${text?.length > 0 ? `&search=${text}` : ''}`
            const res = await ApiGetShopperList(data)
            if (!text || text.length === 0) {
                const sortedList = res.data.sort((a: any, b: any) => {
                    const aHasName = a.firstName && a.firstName.trim() !== '';
                    const bHasName = b.firstName && b.firstName.trim() !== '';

                    if (aHasName && bHasName) {
                        return a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase());
                    }

                    if (aHasName && !bHasName) return -1;

                    if (!aHasName && bHasName) return 1;

                    return 0;
                });

                setshopperlist(sortedList)
            } else {
                setshopperlist(res.data)
            }

        } catch (error) {
            alert(error)
        }
    }

    useEffect(() => {
        getShopperList(searchShopper);
    }, [searchShopper])



    const CheckShopperEligibility = async () => {
        if (!selectedAllocation || !selectedShopper) {
            toast.error("Both allocation and shopper is required")
            return;
        }
        try {
            setData([])
            const data = `?userId=${selectedShopper?.userId}&allocationId=${selectedAllocation}`
            const res = await ApiCheckShopperEligibility(data)
            if (res?.status) {
                setData(res)
            }
        } catch (error: any) {
            toast.error(error.message || "Something went wrong")
        }
    }
    console.log("Data", data)
    return (
        <div className="w-100 px-2 py-0 py-md-3">
            <Box className='w-100 border-10 bg-white p-2 py-5'>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        // marginBottom: {xs:"0px",md:"-70px"},
                        flexWrap: 'wrap',
                        gap: 2,
                        marinTop: "23px",
                    }}
                >
                    <Stack direction="row" flexWrap={{ xs: "wrap", md: "nowrap" }} gap={1}>
                        <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={Clientlist}
                                value={selectedClient}
                                getOptionLabel={(option) => option?.clientGroupName}
                                isOptionEqualToValue={(option, value) => option.clientGroupDBName === value.clientGroupDBName}
                                onChange={(event, newValue: any) => {
                                    // setSelectedClient(newValue)
                                    dispatch(setSelectedClientGroup(newValue))
                                    setClientEntityId(null)
                                    setVenueNameValue(null)
                                    setClientEntityList([])
                                }}
                                // defaultValue="mmcommon"
                                renderInput={(params) => <TextField {...params} label="Select Client" />}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                            <Autocomplete
                                disablePortal
                                id="beacon-autocomplete"
                                options={clientEntityList.filter((item: any) => item.clientEntityId !== null)}
                                getOptionLabel={(option) => option?.entityName || ""}
                                onChange={(event, newValue: any) => {
                                    setClientEntityId(newValue?.clientEntityId || null)
                                    if (newValue?.entityName === "Liquor ID") {
                                        sessionStorage.setItem("isLiquor", "true");
                                    } else {
                                        sessionStorage.setItem("isLiquor", "false");
                                    }
                                    if (!newValue) {
                                        setVenueNameValue(null)
                                        sessionStorage.setItem("isLiquor", "false");
                                    }
                                }}
                                value={clientEntityList.find((option: any) => option?.clientEntityId === clientEntityId) || null}
                                renderInput={(params) => <TextField {...params} label="Select Business" />}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: { xs: "100%", md: 200 } }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={venueName}
                                getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                                value={venueName.find((option: any) => option.value === venueNameValue) || null}
                                onChange={(event, newValue: any) => {
                                    setVenueNameValue(newValue?.value || null)
                                    setSearchText("")
                                }}
                                defaultValue=""
                                renderInput={(params) => <TextField {...params} label="Search Site" />}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <h1 style={{ textAlign: "center" }}>Check Shopper Eligibility</h1>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            // marginBottom: "70px",
                        }}
                    >
                        <IconButton onClick={handlePrevMonth}>
                            <ChevronLeftIcon />
                        </IconButton>
                        <Box sx={{ display: "flex", alignItems: "center", mx: 2 }}>
                            <input
                                type="month"
                                value={formatDate(currentDate)}
                                onChange={handleDateChange}
                                className="primary-color"
                                style={{
                                    border: "none",
                                    background: "none",
                                    fontSize: "1.25rem",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    fontFamily: "inherit",
                                }}
                            />
                        </Box>
                        <IconButton onClick={handleNextMonth}>
                            <ChevronRightIcon />
                        </IconButton>
                    </Box>
                </Box>

                <Box className='mt-5 w-100' display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
                    <Box className='d-flex align-items-center g-3'>
                        <FormControl size="small" sx={{ width: { xs: "100%", md: 300 } }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={allocations}
                                getOptionLabel={(option: any) => `${option?.venueId?.venueName}`}
                                value={allocations.find((option: any) => option.allocationId === selectedAllocation) || null}
                                onChange={(event, newValue: any) => {
                                    setSelecetdAllocation(newValue?.allocationId || null)
                                }}
                                defaultValue=""
                                renderInput={(params) => <TextField {...params} label="Search Site" />}
                                size="small"
                            />
                        </FormControl>

                        <FormControl sx={{ ml: 1, width: { xs: "100%", md: 300 } }}>
                            <Autocomplete
                                id='search_shopper'
                                disablePortal
                                // disabled={eventDetails?.type === "Booked"} // Disable if already booked
                                options={shopperlist?.filter((item: any) => item?.firstName !== '')}
                                value={selectedShopper}
                                onInputChange={(event, newInputValue) => {
                                    setsearchShopper(newInputValue)
                                }}
                                getOptionLabel={(option: any) =>
                                    `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`
                                }
                                isOptionEqualToValue={(option: any, value: any) =>
                                    option.userId === value.userId || option.emailId === value.emailId
                                }
                                filterOptions={(options, { inputValue }) =>
                                    options.filter((option) => {
                                        const fullName = `${option?.firstName} ${option.lastName} (${option?.userName}) (${option?.emailId}) (${option?.contactNo})`.toLowerCase();
                                        const email = option.emailId?.toLowerCase() || '';
                                        const search = inputValue.toLowerCase();
                                        return fullName.includes(search) || email.includes(search);
                                    })
                                }
                                onChange={(event, newValue: any) => {
                                    setSelectedShopper(newValue);
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Select Shopper"
                                        size="small"
                                    />
                                }
                                size="small"
                            />
                        </FormControl>
                    </Box>
                    <Button
                        variant="contained"
                        onClick={CheckShopperEligibility}
                        className="table-row-background fs-14 w-auto"
                    >
                        Check Eligibility
                    </Button>
                </Box>
                <Box className='w-100' overflow={'auto'} mt={3}>
                    <Table>
                        <TableHead>
                            <TableRow className="table-row-background">
                                {[
                                    "Error Code",
                                    "Criteria",
                                ].map((item, index) => (
                                    <TableCell key={index} style={{ color: "#fff" }}>
                                        {item}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                data?.reasons?.map((item: any) => (
                                    <TableRow>
                                        <TableCell>{item?.code}</TableCell>
                                        <TableCell>{item?.message}</TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                </Box>
            </Box>

        </div >
    )
}

export default CheckShopperEligibility
